import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { householdEditRecordExpenseUri, householdEditRecordIncomeDetailsUri } from 'Consts/advisorUris';
import { GuidedHouseholdReviewCashFlowLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

export const GuidedHouseholdReviewCashFlowPageTemplate = ({ resource }) => {
  const { householdId } = useSimpleHousehold();
  const editLinkByResourceType = {
    GuidedHouseholdReviewIncomeStep: householdEditRecordIncomeDetailsUri(householdId),
    GuidedHouseholdReviewExpensesStep: householdEditRecordExpenseUri(householdId),
  };
  const { loadPageContentLink, setPageContentCollection, refreshPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      layout={withGuidedHouseholdReviewLayout(GuidedHouseholdReviewCashFlowLayout, { editLink: editLinkByResourceType[resource.type()] })}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink, refresh: refreshPageContentCollection }}
      resource={resource}
    />
  );
};

GuidedHouseholdReviewCashFlowPageTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
